/* ss-deco.js — i bottoni da cucire si muovono mentre scorri.
   Legge la posizione della sezione, non window.scrollY: il tema Next
   in alcuni casi scorre dentro un contenitore suo e l'evento non arriva.
   Vale per ogni sezione marcata data-deco="true", non solo per la hero. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hosts = [].slice.call(document.querySelectorAll('[data-deco="true"]'));
  if (!hosts.length) return;

  hosts.forEach(function (host) {
    var els = [].slice.call(host.querySelectorAll('.ss-btn-deco'));
    if (!els.length) return;

    var running = false, visible = true;

    function frame() {
      var r = host.getBoundingClientRect();
      var p = -r.top;                       // px scorsi oltre l'inizio della sezione
      for (var i = 0; i < els.length; i++) {
        var s = parseFloat(els[i].getAttribute('data-speed')) || 20;
        els[i].style.transform =
          'translate3d(0,' + (p * s / 100).toFixed(1) + 'px,0) rotate(' + (p * s / 260).toFixed(1) + 'deg)';
      }
      if (visible) { window.requestAnimationFrame(frame); } else { running = false; }
    }

    function start() { if (!running) { running = true; window.requestAnimationFrame(frame); } }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start();
      }, { rootMargin: '200px' }).observe(host);
    } else { start(); }
    start();
  });
})();
